<div class="tsd_container commodity-form-dialog">
  <form [formGroup]="commodityForm">
    <mat-card>
      <mat-card-content>
        <h4>{{id.value?'Edit':'Add'}} Commodity</h4>
        <mat-form-field class="mat-width">
          <mat-label>Commodity Name</mat-label>
          <input matInput formControlName="name" autocomplete="off" required>
          @if (name.touched && name.invalid) {
            <mat-error>Commodity Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>Commodity Type</mat-label>
          <mat-select formControlName="commodityType" required>
            @for (commodityType of commodityTypes; track commodityType) {
              <mat-option [value]="commodityType.key">
                {{commodityType.label}}
              </mat-option>
            }
          </mat-select>
          @if (commodityType.touched && commodityType.invalid && commodityType.hasError('required')) {
            <mat-error>Commodity Type is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-width">
          <mat-label>HS Code</mat-label>
          <input matInput formControlName="hsCode" autocomplete="off" required>
          @if (hsCode.touched && hsCode.invalid && hsCode.hasError('required')) {
            <mat-error>HS Code is required</mat-error>
          }
        </mat-form-field>
        @if (commodityType.value=='SPECIAL') {
          <mat-form-field class="mat-width">
            <mat-label>Commodity Group</mat-label>
            <mat-select formControlName="commodityGroup" required>
              <mat-option [value]="null">None</mat-option>
              @for (commodityGroup of commodityGroups; track commodityGroup) {
                <mat-option [value]="commodityGroup.key">
                  {{commodityGroup.label}}
                </mat-option>
              }
            </mat-select>
            @if (commodityGroup.touched && commodityGroup.invalid && commodityGroup.hasError('required')) {
              <mat-error>Commodity Group is required</mat-error>
            }
          </mat-form-field>
        }
        @if (commodityType.value=='HAZ') {
          <mat-form-field class="mat-width">
            <mat-label>IMDG Class</mat-label>
            <input matInput formControlName="imdgClass" autocomplete="off" required>
            @if (imdgClass.touched && imdgClass.invalid && imdgClass.hasError('required')) {
              <mat-error>IMDG Class is required</mat-error>
            }
          </mat-form-field>
        }
        @if (commodityType.value=='HAZ') {
          <mat-form-field class="mat-width">
            <mat-label>IMDG Class Name</mat-label>
            <input matInput formControlName="imdgClassName" autocomplete="off" required>
            @if (imdgClassName.touched && imdgClassName.invalid && imdgClassName.hasError('required')) {
              <mat-error>IMDG Class Name is required</mat-error>
            }
          </mat-form-field>
        }
        <mat-card-actions>
          <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
          <button mat-button color="primary" (click)="save()" [disabled]="!editPermission">SAVE</button>
        </mat-card-actions>
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'COMMODITY'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>

